<template>
  <div class="sal-page">
    <div class="sal-card">
      <div class="sal-card__header">
        <h1 class="sal-title">忘記密碼</h1>
        <p class="sal-subtitle">輸入申請時填寫的信箱，我們將寄送重設連結</p>
      </div>

      <div v-if="sent" class="sal-success">
        <p>✅ 若信箱正確，重設連結已寄出，請於 1 小時內完成重設。</p>
        <router-link :to="{ name: 'StoreAdminLogin' }" class="sal-back-link">← 返回登入</router-link>
      </div>

      <form v-else class="sal-form" @submit.prevent="onSubmit">
        <div class="sal-field">
          <label for="fp-email">信箱</label>
          <input
            id="fp-email"
            v-model.trim="email"
            type="email"
            placeholder="請輸入申請時填寫的信箱"
            class="sal-input"
            autocomplete="email"
          />
        </div>

        <div v-if="apiError" class="sal-api-error">{{ apiError }}</div>

        <button type="submit" class="sal-submit" :disabled="submitting">
          <span v-if="submitting" class="sal-spinner" />
          {{ submitting ? '處理中…' : '送出重設連結' }}
        </button>

        <p class="sal-back">
          <router-link :to="{ name: 'StoreAdminLogin' }">← 返回登入</router-link>
        </p>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'

const email      = ref('')
const submitting = ref(false)
const apiError   = ref('')
const sent       = ref(false)

async function onSubmit() {
  if (!email.value) { apiError.value = '請輸入信箱'; return }
  submitting.value = true
  apiError.value   = ''
  try {
    await axios.post('/api/store-admin/forgot-password', { email: email.value })
    sent.value = true
  } catch (e) {
    apiError.value = e.response?.data?.message || '發生錯誤，請稍後再試'
  } finally {
    submitting.value = false
  }
}
</script>

<style scoped>
.sal-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f6f9;
  padding: 24px 16px;
}
.sal-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 40px 36px;
  width: 100%;
  max-width: 420px;
}
.sal-card__header { text-align: center; margin-bottom: 32px; }
.sal-title { font-size: 1.5rem; color: #2c3e50; margin: 0 0 8px; }
.sal-subtitle { font-size: 0.88rem; color: #95a5a6; margin: 0; }
.sal-form { display: flex; flex-direction: column; gap: 20px; }
.sal-field { display: flex; flex-direction: column; gap: 6px; }
.sal-field label { font-size: 0.88rem; color: #555; font-weight: 500; }
.sal-input {
  width: 100%; padding: 11px 14px; border: 1px solid #dce1e7;
  border-radius: 8px; font-size: 1rem; background: #fff;
  box-sizing: border-box; transition: border-color 0.15s; -webkit-appearance: none;
}
.sal-input:focus { outline: none; border-color: #2c3e50; box-shadow: 0 0 0 3px rgba(44,62,80,0.08); }
.sal-api-error {
  background: #fdedec; border: 1px solid #f5b7b1; border-radius: 8px;
  padding: 12px 14px; font-size: 0.88rem; color: #c0392b; line-height: 1.5;
}
.sal-submit {
  display: flex; align-items: center; justify-content: center; gap: 8px;
  width: 100%; padding: 13px; background: #2c3e50; color: #fff;
  border: none; border-radius: 8px; font-size: 1rem; font-weight: 600;
  cursor: pointer; transition: background 0.15s; margin-top: 4px;
}
.sal-submit:hover:not(:disabled) { background: #34495e; }
.sal-submit:disabled { opacity: 0.6; cursor: not-allowed; }
.sal-spinner {
  display: inline-block; width: 18px; height: 18px;
  border: 2px solid rgba(255,255,255,0.35); border-top-color: #fff;
  border-radius: 50%; animation: spin 0.7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.sal-back { text-align: center; margin-top: 4px; font-size: 0.85rem; }
.sal-back a, .sal-back-link { color: #95a5a6; text-decoration: none; display: block; text-align: center; margin-top: 16px; font-size: 0.85rem; }
.sal-back a:hover, .sal-back-link:hover { color: #555; text-decoration: underline; }
.sal-success { text-align: center; color: #27ae60; font-size: 0.95rem; line-height: 1.7; }
@media (max-width: 480px) { .sal-card { padding: 28px 20px; } }
</style>
